'use strict'

const COLLECTION_FIELD = /[^{}]+(?=\})/g
const COLLECTION_FIELD_INCLUDING_BRACES = /\{[^{}]+(?=\})\}/g
const NON_LETTER_OR_NUMBER = /[^a-zA-Z0-9]/g

const cleanUrl = url => url.replace(/(\/{2,})/g, '/').replace(/^\//, '')

const parseUrlPattern = pattern => {
  pattern = cleanUrl(pattern)
  return {
    fields: pattern.match(COLLECTION_FIELD) || [],
    nonFields: pattern
      .replace(COLLECTION_FIELD, '')
      .split(NON_LETTER_OR_NUMBER)
      .filter(x => !!x)
  }
}

const parseUrl = url => {
  url = cleanUrl(url)
  const urlParts = url.split('/').filter(s => s.length > 0)
  const pattern = '/' + urlParts.slice(1).join('/')
  return {
    prefix: urlParts[0],
    pattern
  }
}

const buildUrl = (prefix, pattern) => cleanUrl(`${prefix}/${pattern}`)

const constructUrl = (record, dynamicUrl) => {
  return (
    '/' +
    cleanUrl(dynamicUrl)
      .replace(COLLECTION_FIELD_INCLUDING_BRACES, match => {
        const fieldName = match.substring(1, match.length - 1)
        return record[fieldName]
      })
      .replace(' ', '-')
  )
}

const addField = (url, field) => cleanUrl(`${url}/{${field}}`)

const isEqual = (url1, url2) => cleanUrl(url1) === cleanUrl(url2)

// exports

module.exports = {
  cleanUrl,
  buildUrl,
  addField,
  isEqual,
  parseUrl,
  parseUrlPattern,
  constructUrl
}



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/dynamic-pages/urlUtils.js